import { render, staticRenderFns } from "./FilterCategoryButton.vue?vue&type=template&id=c1ad87b2&scoped=true&"
import script from "./FilterCategoryButton.vue?vue&type=script&lang=js&"
export * from "./FilterCategoryButton.vue?vue&type=script&lang=js&"
import style0 from "./FilterCategoryButton.vue?vue&type=style&index=0&id=c1ad87b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ad87b2",
  null
  
)

export default component.exports